import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthProvider } from './providers'
import { App } from './App.jsx'
import axios from 'axios'
import { REFRESH_TOKEN } from './api'

const logout = () => {
    localStorage.removeItem('projectHeroLogin')
    window.location.reload()
}

axios.interceptors.request.use(
    (config) => {
        const projectHeroLogin = JSON.parse(localStorage.getItem('projectHeroLogin'))
        const accessToken = projectHeroLogin?.accessToken
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`
        }
        return config
    },
    (error) => {
        Promise.reject(error)
    }
)

axios.interceptors.response.use(
    (response) => {
        return response
    },
    function (error) {
        const originalRequest = error.config
        const projectHeroLogin = JSON.parse(localStorage.getItem('projectHeroLogin'))
        const refreshToken = projectHeroLogin?.refreshToken
        const accessToken = projectHeroLogin?.accessToken

        if (refreshToken && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true
            const ult = 'otp'
            const dt = 'web'
            const ut = 'customer'

            const payload = { ult, dt, ut, refreshToken, accessToken }
            return axios.post(REFRESH_TOKEN, payload).then((res) => {
                if (res.status === 200) {
                    if (!res.data.success) {
                        return logout()
                    }

                    const newAccessToken = res.data.data.accessToken

                    const localStoragePayload = {
                        ...projectHeroLogin,
                        accessToken: newAccessToken,
                        isUpated: true,
                    }

                    localStorage.removeItem('projectHeroLogin')
                    localStorage.setItem('projectHeroLogin', JSON.stringify(localStoragePayload))
                    console.log('Access token refreshed')
                    return axios(originalRequest)
                }
            })
        }
        return Promise.reject(error)
    }
)

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <AuthProvider>
                <App />
            </AuthProvider>
        </Router>
    </React.StrictMode>,
    document.getElementById('root')
)
